function modernizrTouch() {

    if(Modernizr.touch) {
        document.documentElement.className += " is-touch";
    } else {
        document.documentElement.className += " no-touch";
    }

    if(Modernizr.touch) {
        $('nav#dl-menu a.submenu').click(function(e) {
            e.preventDefault();
        });

        $('nav#dl-menu li.submenu').click(function() {
            $('nav#dl-menu .hover').removeClass('hover');
            $(this).addClass('hover');
        });

        $('#wrapper').click(function(e) {
            if($(e.target).parents('#dl-menu').length != 1) {
                $('nav#dl-menu .hover').removeClass('hover');
            }
        });
    }

}